type GestureListener = () => void;

class UserGestureManager {
  hasUserGesture = false;

  listeners: GestureListener[] = [];

  constructor() {
    const markGesture = (event: Event): void => {
      if (!event.isTrusted || this.hasUserGesture) {
        return;
      }
      this.hasUserGesture = true;
      document.removeEventListener('keydown', markGesture, true);
      document.removeEventListener('pointerdown', markGesture, true);
      document.removeEventListener('click', markGesture, true);
      this.listeners.forEach(listener => listener());
    };
    document.addEventListener('keydown', markGesture, true);
    document.addEventListener('pointerdown', markGesture, true);
    document.addEventListener('click', markGesture, true);
  }

  addGestureListener = (listener: GestureListener): void => {
    this.listeners.push(listener);
  };

  removeGestureListener = (listener: GestureListener): void => {
    this.listeners = this.listeners.filter(item => item !== listener);
  };
}

export default new UserGestureManager();
